import React from "react";
import "./CreditsInsufficient.scss";
import Button, { EButtonType } from "../../Buttons/Button";
import { useTranslation } from "react-i18next";

const CreditsInsufficient = (props) => {

    const { amount, requiredAmount, creditPurchaseUrl } = props;

    const { t } = useTranslation();

    return (
        <div className="creditsInsufficient">
            <div className="creditsInsufficientHeader">
                {t("reseller.creditsInsufficient.header")}
            </div>
            <div className="creditsInsufficientContent">
                <div>
                    {t("reseller.creditsInsufficient.content")}
                </div>
                <div className="creditsInsufficientBalances">
                    <div className="creditsInsufficientBalance">
                        {t("reseller.creditsInsufficient.current")} <span className="creditsInsufficientAmount">{amount}</span>
                    </div>
                    <div className="creditsInsufficientBalance">
                        {t("reseller.creditsInsufficient.required")} <span className="creditsInsufficientAmount">{requiredAmount}</span>
                    </div>
                </div>
                <Button
                    text={t("reseller.creditsInsufficient.button")}
                    buttonType={EButtonType.PRIMARY}
                    onClick={() => window.location.href = creditPurchaseUrl}
                />
            </div>
        </div>
    );
};

export default CreditsInsufficient;